import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DialogService, DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { MessageService, ConfirmationService, PrimeNGConfig } from 'primeng/api';
import { Title } from '@angular/platform-browser';
import moment from 'moment';
import { CommonService } from '../../../../services/common/common.service';
import { QuizAnswersDataService, QuizAnswersColumnsService } from '../../../services';
import { QuizAnswer, QuizAnswersResult } from '../../../interfaces';

@Component({
  selector: 'app-quiz-answer-form',
  templateUrl: './quiz-answer-form.component.html',
  styleUrls: ['./quiz-answer-form.component.scss'],
  providers: [MessageService, ConfirmationService, DynamicDialogRef, DynamicDialogConfig],
})
export class QuizAnswerFormComponent implements OnInit, OnDestroy, AfterViewInit {

  public quizAnswer: QuizAnswer = {};
  public quizAnswerForm: FormGroup = new FormGroup({});
  public quizAnswers: QuizAnswer[] = [];
  public defaultParameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public parameters: {[param: string]: string | string[]} = {offset: '0', limit: '1000'};
  public isLoading: boolean = false;
  public locale: string = (localStorage.language)?localStorage.language:'en';
  public redirect = true;
  public disableSubmit = false;
  public enableFormAlert = true;


  constructor(
    private translate: TranslateService,
    public common: CommonService,
    private router: Router,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private dynamicDialogConfig: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private primengConfig: PrimeNGConfig,
    private titleService: Title,
    private quizAnswersDataService: QuizAnswersDataService,
    public quizAnswersColumnsService: QuizAnswersColumnsService,
  ) {
  }

  ngOnInit(): void {
    console.log('ngOnInit', 'QuizAnswerFormComponent');
    this.route.params.subscribe((params: any) => {
      if (typeof params['id'] !== 'undefined') {
        this.titleService.setTitle('Quiz Answer - Edit');
        this.getQuizAnswer(parseInt(params['id'], 10));
      }
    });
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.quizAnswer !== 'undefined') {
      this.quizAnswer = this.dynamicDialogConfig.data.quizAnswer;
    }
    if (typeof this.quizAnswer.id === 'undefined' || this.quizAnswer.id === null) {
      this.quizAnswer.id = null;
      this.quizAnswer.isCorrect = false;
      this.quizAnswer.isWinner = false;
    }
    this.getQuizAnswers();
    this.prepareFrom();
  }

  ngOnDestroy(): void {
    console.log('ngOnDestroy', 'QuizAnswerFormComponent');
  }

  ngAfterViewInit(): void {
    console.log('ngAfterViewInit', 'QuizAnswerFormComponent');
  }

  getQuizAnswer(id: number): void {
    this.isLoading = true;
    this.quizAnswersDataService.getQuizAnswer(id).subscribe((response: QuizAnswer|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.quizAnswer = response;
        this.prepareFrom();
      }
    });
  }

  getQuizAnswers(): void {
    if (this.dynamicDialogConfig.data && typeof this.dynamicDialogConfig.data.quizAnswers !== 'undefined' && this.dynamicDialogConfig.data.quizAnswers.length > 0) {
      this.quizAnswers = this.dynamicDialogConfig.data.quizAnswers;
      return;
    }
    this.quizAnswersDataService.getQuizAnswers(this.parameters).subscribe((response: QuizAnswersResult|any) => {
      this.isLoading = false;
      if (response !== null) {
        this.quizAnswers = response.results;
      }
    });
  }

  prepareFrom(): void {
    this.quizAnswerForm = new FormGroup({
      id: new FormControl(this.quizAnswer.id, []),
      quiz: new FormControl((typeof this.quizAnswer.quiz === 'number') ? this.quizAnswer.quiz : this.quizAnswer.quiz?.id, [Validators.required, ]),
      answer: new FormControl(this.quizAnswer.answer, [Validators.required, ]),
      isCorrect: new FormControl(this.quizAnswer.isCorrect, [Validators.required, ]),
      isWinner: new FormControl(this.quizAnswer.isWinner, [Validators.required, ]),
      responseTime: new FormControl(this.quizAnswer.responseTime, []),
    });
  }

  list() {
    this.router.navigate(['/quiz-answers']);
  }

  showErrors() {
      this.showErrors();
      const invalidFields: string[] = [];
      Object.keys(this.quizAnswerForm.controls).forEach((field: any) => {
        const control = this.quizAnswerForm.get(field);
        if (control !== null) {
          control.markAsTouched({ onlySelf: true });
          if (control.invalid) {
            invalidFields.push(field);
          }
        }
      });
  }

  submitForm(redirect: boolean) {
    this.redirect = redirect;
    if (!this.quizAnswerForm.valid) {
      this.showErrors();
    } else {
      this.saveData(redirect);
    }
  }

  saveData(redirect: boolean) {
    this.quizAnswer = this.quizAnswerForm.value;
    this.disableSubmit = true;
    console.log('quizAnswer', this.quizAnswer);
    if (typeof this.quizAnswer.id !== 'undefined' && this.quizAnswer.id !== null) {
      this.add(redirect);
    } else {
      this.update(redirect);
    }
    return false;
  }

  add(redirect: boolean) {
    this.quizAnswersDataService.updateQuizAnswer(this.quizAnswer).subscribe((data: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('QUIZANSWERUPDATED')});
      if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
        this.dynamicDialogRef.close({refresh: true});
      } else if (redirect) {
        this.list();
      }
    }, (error: any) => {
      this.disableSubmit = false;
      this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('QUIZANSWERNOTUPDATED') + ' ' + error.message});
      console.warn(error);
    });
  }

  update(redirect: boolean) {
    this.quizAnswersDataService.addQuizAnswer(this.quizAnswer).subscribe((data: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'success', summary: this.translate.instant('NOTIFICATION'), detail: this.translate.instant('QUIZANSWERCREATED')});
        if (redirect && typeof this.dynamicDialogConfig.data !== 'undefined') {
          this.dynamicDialogRef.close({refresh: true});
        } else if (redirect) {
          this.list();
        }
      }, (error: any) => {
        this.disableSubmit = false;
        this.messageService.add({severity: 'error', summary: this.translate.instant('ERROR'), detail: this.translate.instant('QUIZANSWERNOTCREATED') + ' ' + error.message});
        console.warn(error);
    });
  }

}

@Component({
  selector: 'app-quiz-answer-form',
  templateUrl: './quiz-answer-form.component.html',
  styleUrls: ['./quiz-answer-form.component.scss'],
  providers: [MessageService, ConfirmationService],
})
export class DialogQuizAnswerFormComponent extends QuizAnswerFormComponent {
}

